import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProfileInfoDto } from '../../interfaces/profile/profile';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProfileGateway {
  private urlPrefix: string = '/profile';
  constructor(private httpClient: HttpClient) {}

  public getProfileInfo(): Observable<ProfileInfoDto> {
    return this.httpClient.get<ProfileInfoDto>(`${environment.api.url}${this.urlPrefix}`);
  }
}
